<template>
  <div class="knowlegdebank-filter">
    <div class="knowlegdebank-filter__options">
      <label title="article" for="">
        <input value="article" class="knowlegdebank-filter__input" type="radio" />
        Artikel
      </label>
      <label title="article" for="">
        <input type="radio" />
        Dom
      </label>
      <label title="article" for="">
        <input type="radio" />
        Kendelse
      </label>
    </div>
  </div>
</template>

<script>
export default {
  name: "FilterComponent",
  data() {
    return{
        
    }
  },
  computed: {
  }
};
</script>
